import { createActionGroup, props } from '@ngrx/store';
import { ProfessionTree } from '../../models/profession-tree.model';

const actions = createActionGroup({
    source: 'Profession & Specialty Configuration',
    events: {
        'Load Profession Tree': props<{ force?: boolean }>(),
        'Load Profession Tree Success': props<{ data: ProfessionTree }>(),
        'Load Profession Tree Failure': props<{ error: unknown }>()
    }
});

export const { loadProfessionTree, loadProfessionTreeSuccess, loadProfessionTreeFailure } = actions;
